/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/K8sConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const K8sConfigCardTestIds = {
  btnCreateK8sConfig: "btn-create-k8s-config",
  btnEditK8sConfig: "btn-edit-k8s-config",
  cardTitleK8sConfig: "card-title-k8s-config",
  k8sConfigCard: "k8s-config-card",
  selectK8sAuthType: "select-k8s-auth-type"
} as const;
